module.exports = __webpack_public_path__ + "img/indoor.d80d00bf.jpg";